import { ReportType } from "./typings/global";
import { GConfig } from "./config";
import Logger from "./core/logger";
import Collecter from "./core/collecter";
import Reporter from "./core/reporter";

export class GrafanaReporter {
  collecter: Collecter;
  reporter: Reporter;

  constructor() {
    this.collecter = new Collecter();
    this.reporter = new Reporter();
  }

  /**
   * 修改配置信息
   */
  setConfig(config: ReportType.GConfig) {
    const conf = { ...GConfig, ...(config || {}) };
    this.collecter.setConfig(conf);
    this.reporter.setConfig(conf);
  }

  /**
   * 仅收集日志，不上报
   */
  collectLog(params: ReportType.LogInfo) {
    return this.collecter.add(new Logger(params));
  }

  /**
   * 立即上报（立即上报 + 忽略定频）
   * 清空所有收集的日志，立即上报
   */
  report(params: ReportType.LogInfo) {
    this.collecter.add(new Logger(params));
    return this.reporter.report(this.collecter, true, false);
  }

  /**
   * 定频上报（立即上报 + 定频）
   * 冷却时间内延迟上报，否则立即上报
   */
  freqReport(params: ReportType.LogInfo) {
    this.collecter.add(new Logger(params));
    return this.reporter.report(this.collecter, true, true);
  }

  /**
   * 延迟上报（延迟上报 + 定频）
   * 统一延迟定频上报
   */
  delayReport(params: ReportType.LogInfo) {
    this.collecter.add(new Logger(params));
    return this.reporter.report(this.collecter, false, true);
  }
}

export default new GrafanaReporter();
